import applicationFormService from '../../services/applicationForm.service';
import {
  BankAccountInput,
  BankConnectionDetails,
  BankConnectionTypes,
  HardDecline,
  SoftDecline,
  UpdateBankAccountInput,
  UpdateBankAccountResponse,
} from '../../gql/graphql';
import { NetworkError } from '../../state-machine/actions/genericActions';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';

export type UpdateBankAccountResult = UpdateBankAccountResponse & {
  // parsed here for easy usage
  hardDeclineError: HardDecline | undefined;
  softDeclineError: SoftDecline | undefined;
};

const updateBankAccount = async (appId: number, accountNumber: string, routingNumber: string): Promise<UpdateBankAccountResult | undefined> => {
  const bankDetails: BankAccountInput = {
    accountNumber,
    routingNumber,
  };
  const updateBankAccountPayload: UpdateBankAccountInput = {
    applicationId: appId,
    bankAccount: bankDetails,
  };
  try {
    const { data } = await applicationFormService.updateBankAccount(updateBankAccountPayload);
    if (!data?.updateBankAccount) return undefined;

    return {
      ...data.updateBankAccount,
      hardDeclineError: (data?.updateBankAccount?.updateBankAccountErrors?.find((err) => err.__typename === 'HardDecline') as HardDecline) || undefined,
      softDeclineError: (data?.updateBankAccount?.updateBankAccountErrors?.find((err) => err.__typename === 'SoftDecline') as SoftDecline) || undefined,
    } as UpdateBankAccountResult;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

const plaidUpdateBankAccount = async (appId: number, plaidPublicToken: string, plaidLinkToken: string) => {
  const connectDetails: BankConnectionDetails = {
    bankConnectionType: BankConnectionTypes.Plaid,
    bankConnectionToken: plaidPublicToken,
    bankConnectionCreationToken: plaidLinkToken,
  };
  const updateBankAccountPayload: UpdateBankAccountInput = {
    applicationId: appId,
    bankConnectionDetails: connectDetails,
  };
  try {
    const { data, errors } = await applicationFormService.updateBankAccount(updateBankAccountPayload);
    if (errors) throw errors;

    return data?.updateBankAccount;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export { plaidUpdateBankAccount, updateBankAccount };
